import { useCallback } from 'react';

import { useApiResetPasswordConfirmCreate } from 'state/__generated__/tadaahAPI';
import type { PasswordResetConfirm } from 'state/__generated__/tadaahAPI';

type UseFreelancerConfirmResetPasswordReturnType = {
  resetPassword: (values: PasswordResetConfirm) => Promise<void>;
  isLoading?: boolean;
  error: Error | null;
  initialValues: PasswordResetConfirm;
};

const initialValues: PasswordResetConfirm = {
  new_password1: '',
  new_password2: '',
  token: '',
  uid: '',
};

const useFreelancerConfirmResetPassword =
  (): UseFreelancerConfirmResetPasswordReturnType => {
    const { mutateAsync, error, isLoading } =
      useApiResetPasswordConfirmCreate<Error>({
        mutation: {
          mutationKey: 'freelancer-confirm-reset-password',
        },
      });

    const resetPassword = useCallback(
      async (values: PasswordResetConfirm) => {
        const response = await mutateAsync({ data: values });
        if (response.status !== 200) throw new Error('Something went wrong');
      },
      [mutateAsync],
    );

    return {
      error,
      initialValues,
      isLoading,
      resetPassword,
    };
  };

export default useFreelancerConfirmResetPassword;
